import { RootState } from 'store/root-reducer';

export const getTotalTraffic = (state: RootState) => state.statistics.totalTransits;
